import * as yup from 'yup';
import { nullableNumber } from '../components/common/FormUtils';

export const juustotJaMuutTuotteetSchema = yup.object().shape({
  KypsytetytJuustot: nullableNumber,
  Tuorejuustot: nullableNumber,
  Raejuusto: nullableNumber,
  Sulatejuustot: nullableNumber,
  Leipajuusto: nullableNumber,
  Kutunjuusto: nullableNumber,
  VoiRasvapit80ProsJaYli: nullableNumber,
  VoiRasvapitAlle80Pros: nullableNumber,
  Rasvaseokset: nullableNumber,
  RasvaseoksetJostaMaitorasvaa: nullableNumber,
  VoiOljy: nullableNumber,
  RasvainenMaitojauhe: nullableNumber,
  RasvatonMaitojauhe: nullableNumber,
  KirnupiimaJaKirnumaitojauheet: nullableNumber,
  Herajauheet: nullableNumber,
  DemineralisoituHerajauhe: nullableNumber,
  MuutHeraMaitoJaSeosjauheet: nullableNumber,
  Laktoosi: nullableNumber,
  KaseiiniJaKaseinaatit: nullableNumber,
  MuutMaitotuotteet: nullableNumber,
  KypsytetytJuustotSuoraanKulutukseen: nullableNumber,
  TuorejuustoSuoraanKulutukseen: nullableNumber,
  LeipäjuustoSuoraanKulutukseen: nullableNumber,
  KypsytetytJuustotVarasto: nullableNumber,
  VoiVarasto: nullableNumber,
});
